import { useTheme, Box, Typography, Button } from '@mui/material';
import { East } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const BlogPostPreview = ({ post }) => {
  const { imageUrl, title, preview, postUrl } = post;
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'column',
        borderRadius: `${theme.spacingValues.medium}`,
        backgroundColor: `${theme.palette.grey[50]}`,
        padding: `${theme.spacingValues.mediumLarge}`,
        maxWidth: { xs: '100%', sm: '413px' },
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: theme.spacingValues.medium,
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt={title}
          sx={{
            borderRadius: `${theme.spacingValues.medium}`,
            width: '100%',
            height: '138px',
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
        <Typography
          variant="h4"
          sx={{
            marginTop: `${theme.spacingValues.medium}`,
            color: `${theme.palette.primary.main}`,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            marginTop: `${theme.spacingValues.medium}`,
          }}
        >
          {preview}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        size="large"
        sx={{
          marginTop: `${theme.spacingValues.medium}`,
          color: `${theme.palette.primary.main}`,
        }}
        component={RouterLink}
        to={postUrl}
        endIcon={<East />}
      >
        Leia mais
      </Button>
    </Box>
  );
};

export default BlogPostPreview;
